import React from 'react';
import { useParams } from 'react-router-dom';
import CreatePerformanceReview from './CreatePerformanceReview';

const EditPerformanceReview = () => {
  const { id } = useParams();

  return <CreatePerformanceReview editMode={true} reviewId={id} />;
};

export default EditPerformanceReview;

